<template>
  <div>
    <el-popover
      :popper-options="popoverOptions"
      ref="customAttrsPopover"
      :placement="placement"
      width="300"
      trigger="click"
      @after-leave="dynamicAttrKey = new Date().getTime()"
    >
      <form-item :label="$t('CampaignForm_Field_DynamicAttrs')">
        <el-autocomplete
          :key="dynamicAttrKey"
          ref="customAttrsInput"
          v-model="dynamicAttr"
          :fetch-suggestions="querySearchAttrs"
          @select="handleSelectAttr"
          :popper-append-to-body="false"
        />
      </form-item>
    </el-popover>
    <el-popover
      :popper-options="popoverOptions"
      ref="snippetPopover"
      :placement="placement"
      width="300"
      trigger="click"
      @after-leave="snippetKey = new Date().getTime()"
    >
      <form-item :label="$t('CampaignForm_Field_Snippet')">
        <el-autocomplete
          :key="snippetKey"
          ref="snippetInput"
          v-model="snippet"
          :fetch-suggestions="querySearchSnippet"
          @select="handleSelectSnippet"
          :popper-append-to-body="false"
        />
      </form-item>
    </el-popover>
    <el-popover
      :popper-options="popoverOptions"
      ref="optimovePopover"
      :placement="placement"
      width="300"
      trigger="click"
      @after-leave="optimoveKey = new Date().getTime()"
    >
      <form-item :label="$t('CampaignForm_Field_Optimove')">
        <el-autocomplete
          ref="optimoveInput"
          :key="optimoveKey"
          v-model="optimoveInput"
          :fetch-suggestions="querySearchOptimove"
          @select="handleSelectOptimove"
          :popper-append-to-body="false"
        />
      </form-item>
    </el-popover>
    <el-popover
      :popper-options="popoverOptions"
      ref="salesforcePopover"
      :placement="placement"
      width="300"
      trigger="click"
      @after-leave="salesforceKey = new Date().getTime()"
    >
      <form-item :label="$t('CampaignForm_Field_Salesforce')">
        <el-autocomplete
          ref="salesforceInput"
          :key="salesforceKey"
          v-model="salesforceInput"
          :fetch-suggestions="querySearchSalesforce"
          @select="handleSelectSalesforce"
          :popper-append-to-body="false"
        />
      </form-item>
    </el-popover>
    <div class="container">
      <div class="actions" v-if="textarea">
        <el-button-group>
          <el-button v-if="emoji" class="dropdown-btn emoji-picker-textarea">
            <emoji-picker :on-select="insertEmoji" />
          </el-button>
          <el-button
            v-if="attributes"
            v-popover:customAttrsPopover
            @click="putCursor('customAttrsInput')"
            class="dropdown-btn"
            icon="el-icon-user-solid"
          />
          <el-button
            v-if="snippets"
            v-popover:snippetPopover
            @click="putCursor('snippetInput')"
            class="dropdown-btn"
            icon="icon icon-code"
          />
          <el-button
            v-if="optimove"
            v-popover:optimovePopover
            @click="putCursor('optimoveInput')"
            class="dropdown-btn"
            icon="icon iconp-Optimove-Head"
          />
          <el-button
            v-if="salesforce"
            v-popover:salesforcePopover
            @click="putCursor('salesforceInput')"
            class="dropdown-btn"
            icon="icon iconp-salesforce"
          />
        </el-button-group>
      </div>
      <el-input
        v-model="inputVal"
        :type="type"
        v-loading="loading"
        :placeholder="placeholder"
        :data-qa="dataQa"
      >
        <div slot="append" class="btn-group" v-if="!textarea">
          <el-button
            v-if="ai && emailChannel"
            @click="generateText()"
            class="dropdown-btn"
            icon="icon iconp-ai"
          />
          <el-button v-if="emoji" class="emoji-picker dropdown-btn">
            <emoji-picker :on-select="insertEmoji" />
          </el-button>

          <el-button
            v-if="attributes"
            v-popover:customAttrsPopover
            @click="putCursor('customAttrsInput')"
            class="dropdown-btn"
            icon="el-icon-user-solid"
          />
          <el-button
            v-if="snippets"
            v-popover:snippetPopover
            @click="putCursor('snippetInput')"
            class="dropdown-btn"
            icon="icon icon-code"
          />
          <el-button
            v-if="optimove"
            v-popover:optimovePopover
            @click="putCursor('optimoveInput')"
            class="dropdown-btn"
            icon="icon iconp-Optimove-Head"
          />
          <el-button
            v-if="salesforce"
            v-popover:salesforcePopover
            @click="putCursor('salesforceInput')"
            class="dropdown-btn"
            icon="icon iconp-salesforce"
          />
        </div>
      </el-input>
    </div>
  </div>
</template>

<script>
import EmojiPicker from '@/common/components/EmojiPicker'
import { $hasFeature } from '@/core/utils/VueAcl'
import FormItem from '@/common/components/form/FormItem'
import { querySearch } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
export default {
  name: 'SnippetInput',
  components: { FormItem, EmojiPicker },
  mounted() {
    EventBus.$on('fetchingData', isFetching => {
      this.loading = isFetching
    })
  },
  destroyed() {
    EventBus.$off('fetchingData')
  },
  data() {
    return {
      dynamicAttrKey: '',
      snippetKey: '',
      optimoveKey: '',
      dynamicAttr: '',
      snippet: '',
      optimoveInput: '',
      salesforceKey: '',
      salesforceInput: '',
      popoverOptions: {
        modifiers: [this.hidePopover, 'offset', 'arrow', 'applyStyle']
      },
      loading: false
    }
  },
  props: {
    value: {
      required: true
    },
    emoji: {
      type: Boolean,
      required: false,
      default: true
    },
    attributes: {
      type: Boolean,
      required: false,
      default: true
    },
    snippets: {
      type: Boolean,
      required: false,
      default: true
    },
    optimove: {
      type: Boolean,
      required: false,
      default: false
    },
    salesforce: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    ai: {
      type: Boolean,
      required: false,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    placeholder: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      required: false
    }
  },
  computed: {
    inputVal: {
      get() {
        if (this.value === null) {
          return ''
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    textarea() {
      return this.type === 'textarea'
    },
    emailChannel() {
      return this.$route.query.channel === 'email'
    }
  },
  methods: {
    hidePopover(data) {
      const refRect = data.offsets.reference
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64
      data.styles.display = refRect.bottom - headerHeight < 0 ? 'none' : 'block'
      return data
    },
    putCursor(ref) {
      setTimeout(() => {
        this.$refs[ref].focus()
      }, 0)
    },
    generateText() {
      EventBus.$emit('generateTitle')
    },
    insertEmoji(emoji) {
      this.inputVal += emoji.data
    },
    querySearchAttrs(queryString, cb) {
      return querySearch(
        `tags`,
        { sort: 'title', show_aliases: 0, title: queryString },
        cb
      )
    },
    handleSelectAttr(item) {
      const check = item.value.match('^[a-zA-Z]+[a-zA-Z0-9_.]{0,}$')
      let prevVal = this.inputVal || ''
      if ($hasFeature('twig')) {
        if (check) {
          this.inputVal = prevVal + `{{ ${item.value} }}`
        } else {
          let path = item.value.replaceAll(`'`, `\\'`)
          this.inputVal = prevVal + `{{ user.attributes['${path}'] }}`
        }
      } else {
        this.inputVal = prevVal + `{{ ${item.value} }}`
      }
      this.dynamicAttr = ''
      this.putCursor('customAttrsInput')
    },
    querySearchSnippet(queryString, cb) {
      return querySearch(
        `snippets`,
        { sort: 'name', type: 1, show_aliases: 0, name: queryString },
        cb
      )
    },
    handleSelectSnippet(item) {
      this.inputVal += `{{ snippet("${item.value}") }}`
      this.snippet = ''
      this.putCursor('snippetInput')
    },
    querySearchOptimove(queryString, cb) {
      return querySearch(
        `optimove-attributes`,
        { sort: 'name', name: queryString },
        cb
      )
    },
    handleSelectOptimove(item) {
      this.inputVal += `{{ optimove.${item.value} }}`
      this.optimoveInput = ''
      this.putCursor('optimoveInput')
    },
    querySearchSalesforce(queryString, cb) {
      return querySearch(
        `salesforce-attributes`,
        { sort: 'title', title: queryString },
        cb
      )
    },
    handleSelectSalesforce(item) {
      this.inputVal += `{{ salesforce.${item.value} }}`
      this.salesforceInput = ''
      this.putCursor('salesforceInput')
    }
  }
}
</script>

<style scoped>
.emoji-picker-textarea {
  padding: 0 !important;
}
.emoji-picker-textarea >>> .el-button {
  padding-left: 7px;
  border: none;
  line-height: 0.7;
  width: 100%;
  height: 100%;
  border-radius: 0;
}
>>> .emoji-picker .btn-icon {
  line-height: 14px;
}
.dropdown-btn {
  padding: 8px;
  width: 35px;
  height: 35px;
  background-color: #fff;
}
.btn-group {
  display: flex;
}
.actions {
  position: absolute;
  z-index: 99;
  right: 0;
}
>>> .el-textarea__inner {
  padding-top: 31px !important;
  height: 120px;
  font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/SnippetInput.vue